import React from 'react';

const SearchYahooMail = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="21"
         viewBox="0 0 24 21"
         fill="none">
      <g clipPath="url(#clip0_30980_445236)">
        <path
          d="M0 5.11227H4.57726L7.24258 11.8235L9.94256 5.11227H14.3988L7.68851 21H3.20332L5.04027 16.79L0.000141746 5.11227H0ZM19.5882 10.4747H14.5969L19.0269 0L24 0.000209268L19.5882 10.4747ZM15.9043 11.4773C17.4358 11.4773 18.6772 12.6992 18.6772 14.2063C18.6772 15.7134 17.4358 16.9353 15.9043 16.9353C14.373 16.9353 13.1318 15.7134 13.1318 14.2063C13.1318 12.6992 14.3733 11.4773 15.9043 11.4773Z"
          fill="#5F01D1" />
      </g>
      <defs>
        <clipPath id="clip0_30980_445236">
          <rect width="24" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchYahooMail;
